import { PoweroffOutlined } from "@ant-design/icons";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

import { Flex } from "antd";
import storage from "../../utils/storage";
import style from "./LogoutBtn.module.scss";

export const LogoutBtn = () => {
  const navigate = useNavigate();

  const logoutSSO = async () => {
    // NOTE: Temporary workaround
    // const [err, res] = await to(authService.logoutSSO());
    // if (err || !res) return;
    window.location.replace("/api/LogoutSSO");
  };

  const logOut = () => {
    logoutSSO();
    storage.clearToken();
    storage.clearRoles();
    storage.clearSelectedDrustvo();
    navigate("/");
  };
  return (
    <Flex
      justify="space-evenly"
      align="center"
      className={style.logoutBtn}
      onClick={logOut}
      gap={4}
    >
      <div className={style.logoutIcon}>
        <PoweroffOutlined />
      </div>
      <span>{t("COMMON.ODJAVI_SE")}</span>
    </Flex>
  );
};
